import { render, staticRenderFns } from "./client-order.vue?vue&type=template&id=3b71a8b6&scoped=true&"
import script from "./client-order.vue?vue&type=script&lang=js&"
export * from "./client-order.vue?vue&type=script&lang=js&"
import style0 from "./client-order.vue?vue&type=style&index=0&id=3b71a8b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b71a8b6",
  null
  
)

export default component.exports